import { render } from "./OtherSubsidies.vue?vue&type=template&id=46bfa1c8"
import script from "./OtherSubsidies.vue?vue&type=script&lang=js"
export * from "./OtherSubsidies.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__